module.exports = __webpack_public_path__ + "img/组 1015.aaf58237.png";